import React from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import { connect } from 'react-redux';
import { Card, Col, Row, Table, Alert, Form, FormGroup } from 'reactstrap';
import { BiMailSend } from "react-icons/bi";
import { FaSearch } from "react-icons/fa";
import { Spinner } from 'react-bootstrap';
import ListSendMailComponent from '../../../components/Admin/send_mails/ListSendMailComponent';
import PaginateComponent from  '../../../components/PaginateComponent';
import ModalComponent from  '../../../components/ModalComponent';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

class SendMailPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			error: false,
			perPage: 0,
			totalPage: 0,
			currentPage: 0,
			from: '',
            to: '',
			messageError: '',
			isNotification: '',
			textNotification: '',
			isSpinner: false,
			listSendMail: [],
			typeSendMail: [],

			isModal: false,
			isBtnConfirm: true,
            btnConfirmDisabled: false,
            titleModal: '',
            modalBody: '',
			contentModal: '',
			alert: {
                error: false,
                message: ''
            },
            action: '',
            actionKey: 0,

			rq_table: {
                per_page: 10,
                page: 0,
                s: '',
                type_send_mail: '',
                date: '',
                order_by: 'id',
                order: 'desc',
            },
            date: '',
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.getlistSendMail();
		this.setState({
			isNotification: this.props.isNotification,
			textNotification: this.props.textNotification,
		})
		if ( this.props.isNotification ) {
			this.props.notification({
				isNotification: false,
				textNotification: ''
			});
		}
	}

	getlistSendMail = () => {
		this.setState({
			isLoading: true
		});

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: this.state.rq_table
		}
		axios.get( process.env.REACT_APP_API_URL + '/api/admin/send-mail/list', config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					listSendMail: ref.data.content.data,
					typeSendMail: ref.data.content.type_send_mail,
					rq_table: ref.data.content.filters,
					perPage: ref.data.content.perPage,
                    totalPage: ref.data.content.total,
                    currentPage: ref.data.content.current_page,
                    from: ref.data.content.from,
                    to: ref.data.content.to
				});
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

	listSendMailRow = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listSendMail.length ) {
                return (
                    this.state.listSendMail.map( (send_mail, key) => {
                        return (
                            <ListSendMailComponent
	                            key={key}
	                            send_mail={send_mail}
	                            actionKey={key}
	                            showModal={ (actionKey, action) => this.showModal(actionKey, action) }
                            />
                        )
                    })
                );
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có dữ liệu!
                        </td>
                    </tr>
                );
            }
        }
    }

    checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

	sort = (order_by) => {
		this.setState(
			{
				rq_table: {
			        ...this.state.rq_table, 
					order_by: order_by, 
					order: this.state.rq_table.order === 'desc' ? 'asc' : 'desc'
			    }
			},
			() => this.getlistSendMail()
		)
	}	

	change = (e) => {
		this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value,
					page: 0
			    }
			},
			() => this.getlistSendMail()
		)
	}

	changeInput = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		})
	}

    changeQtt = async (event) => {
        let value = event.target.value;
        await this.setState({
            rq_table: {
                ...this.state.rq_table, 
                per_page: value,
                page: 0,
            }
        })
        await this.getlistSendMail();
    }

    search = (e) => {
	    this.setState(
	    	{
		    	rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value
			    }
		    }
	    )
    }

    setDate = (date) => {
    	let dateFormat = moment(date).format('DD/MM/YYYY');
    	if (moment(dateFormat, 'DD/MM/YYYY', true).isValid()) {
	        this.setState({
	        	rq_table: {
			        ...this.state.rq_table, 
					date: dateFormat
			    },
			    date: date
	        });
    	} else {
    		this.setState({
    			rq_table: {
			        ...this.state.rq_table, 
					date: ''
			    },
			    date: ''
    		})
    	}
    }

    submitSearch = (e) => {
        if(e.key === 'Enter') {
        	this.setState(
				{
					currentPage: 0,
					rq_table: {
				        ...this.state.rq_table,
						page: 0
				    }
				},
				() => this.getlistSendMail()
			)
        }
    }

    btnSearch = () => {
        this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table,
					page: 0
			    }
			},
			() => this.getlistSendMail()
		)
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
		this.setState(
			{
				currentPage: page,
				rq_table: {
			        ...this.state.rq_table, 
					page: page
			    }
			},
			() => this.getlistSendMail()
		)
    }

    showModal = (key, action) => {
    	let titleModal;
    	let modalBody;
        if ( action === 'detail' ) {
        	titleModal = 'Chi tiết mail gửi';
        	modalBody =  this.modalBody(action, this.state.listSendMail[key]);
        }

        this.setState({
        	isModal: true,
            action: action,
            btnConfirmDisabled: false,
            isBtnConfirm: true,
            actionKey: key,
            contentModal: {
            	title: titleModal,
                modalBody: modalBody
            }
        });
    } 

    modalBody = (action, send_mail) => {
    	if ( action === 'detail' ) {
            return (
            	<Form>
			        <FormGroup row className="mb-2">
			          <Col sm={2} className="text-md-right font-weight-bold">Loại</Col>
			          <Col sm={10}>
			            <div id="titleSendMail">
			            	{ send_mail.type_send_mail }
			            </div>
			          </Col>
			        </FormGroup>
			        <FormGroup row className="mb-2">
			          <Col sm={2} className="text-md-right font-weight-bold">Tiêu đề</Col>
			          <Col sm={10}>
			            <div id="titleSendMail">
			            	{ send_mail.subject }
			            </div>
			          </Col>
			        </FormGroup>
			        <FormGroup row className="mb-2">
			          <Col sm={2} className="text-md-right font-weight-bold">Ngày tạo</Col>
			          <Col sm={10}>
			            <div id="createdSendMail">
			            	{ send_mail.dateCreated }
			            </div>
			          </Col>
			        </FormGroup>
			        <FormGroup row className="mb-2">
			          <Col sm={2} className="text-md-right font-weight-bold">Đến</Col>
			          <Col sm={10}>
			            <div id="createdSendMail">
			            	{ send_mail.user_email }
			            </div>
			          </Col>
			        </FormGroup>
			        <FormGroup row className="mb-2">
			          <Col sm={2} className="text-md-right font-weight-bold">Trạng thái</Col>
			          <Col sm={10}>
			          	<div dangerouslySetInnerHTML={{ __html: send_mail.status_text }} />
			          </Col>
			        </FormGroup>
			        <FormGroup row className="mb-2">
			          <Col sm={2} className="text-md-right font-weight-bold">Nội dung</Col>
			          <Col sm={10}>
			          	<div id="contentSendMail" style={{ border: 'dashed 1px #8f8f8f', padding: 10, borderRadius: 5, overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: send_mail.content }} />
			          </Col>
			        </FormGroup>
	        	</Form>
            );
    	} 
    }

    hiddenModal = () => {
        this.setState({
            action: '',
            isModal: false,
            alert: {
                error: false,
                message: ''
            }
        })
    }

    confirmModal = () => {
    	this.hiddenModal()
    }

	render() {
		return (
			<>
                <Breadcrumb title={"Quản lý gửi mail"} page={"Quản lý gửi mail"} icon={<BiMailSend className="breadcrumb-icon" />} />

                <Row>
					<Col sm={12}>
						{ this.state.error ? (<Alert color="danger"><div className='text-center'>{ this.state.messageError }</div></Alert>) : (<></>)}
						{this.checkNotification()}

					</Col>
				</Row>

                <Card body>
                    <Row>
                    	<Col sm={12} className="form-inline mb-2">
                    		<select className="form-control form-control-sm mr-1" style={{ maxWidth: 70 }} value={this.state.rq_table.per_page} onChange={ this.changeQtt }>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                            </select>
						</Col>
						<Col sm={12} className="mb-3">
							<Row className="float-md-right d-sm-flex">
								<Col sm={12} md={6} lg={4}>
									<div className="form-group m-1">
			                            <div className="input-group">
			                                <input 
			                                	type="text" name="s" 
			                                	className="form-control form-control-sm"
			                                    placeholder="name, email" 
			                                    id="search"
			                                    onChange={ this.search }
			                                    onKeyPress={ this.submitSearch }
			                                />
		                                    <div className="input-group-append">
		                                        <button type="button" className="btn btn-sm btn-danger" onClick={ () => this.btnSearch() }>
		                                            <FaSearch  />
		                                        </button>
		                                    </div>
			                            </div>
			                        </div>
								</Col>
								<Col sm={12} md={6} lg={4}>
									<div className="form-group m-1">
			                            <div className="input-group" >
			                                <DatePicker
			                                	dateFormat="dd/MM/yyyy"
			                                	className="form-control form-control-sm"
                                                id="date"
		                                		selected={this.state.date}
		                                		onChange={(date) => this.setDate(date)}
		                                		placeholderText="Ngày (dd/mmm/yyyy)"
                                                autoComplete="off"
                                            />
		                                    <div className="input-group-append" style={{ position: 'absolute', right: 0 }}>
		                                        <button type="button" className="btn btn-sm btn-danger" onClick={ () => this.btnSearch() }>
		                                            <FaSearch  />
		                                        </button>
		                                    </div>
			                            </div>
			                        </div>
								</Col>
								<Col sm={12} md={6} lg={4}>
									<select className="form-control select2 form-control-sm m-1" name="type_send_mail" onChange={ this.change } defaultValue={''} >
					                    <option value="">--Chọn hành động--</option>
					                    {
					                    	Object.entries(this.state.typeSendMail)
										  	.map(
										   		([key, type]) => (<option key={key} value={key}>{type}</option>)
										  	)
										}
					                </select>
								</Col>
							</Row>
						</Col>
						{
	                        this.state.listSendMail.length ? (
	                        	<>
	                        		<Col md={12}>
		                                Hiển thị từ { this.state.from } đến { this.state.to } / Tổng: { this.state.totalPage }
		                            </Col>
	                	 		</>
	                        ) : (
	                        <></>
	                        )
	                    }
                    	<Col sm={12} className="table-responsive">
                    		<Table className="table table-sm table-bordered table-hover rounded">
		                        <thead className="primary">
		                            <tr>
		                                <th className={'text-center'} width="10%">Khách hàng</th>
		                                <th className={'text-center'} width="10%">Email</th>
		                                <th className={'text-center'} width="20%">Loại</th>
		                                <th className={'text-center'} width="20%">Tiêu đề</th>
		                                <th className={'text-center'} width="15%">Ngày tạo</th>
		                                <th className={'text-center'} width="20%">Trạng thái</th>
		                                <th className={'text-center'} width="5%">Action</th>
		                            </tr>
		                        </thead>
		                        <tbody>
		                            { this.listSendMailRow() } 
		                        </tbody>
		                    </Table>
		                    <Row>
		                    	{
			                        this.state.listSendMail.length ? (
			                        	<>
			                        		<Col md={12} className="mb-2">
				                                Hiển thị từ { this.state.from } đến { this.state.to } / Tổng: { this.state.totalPage }
				                            </Col>
			                	 		</>
			                        ) : (
			                        <></>
			                        )
			                    }
		                    </Row>
		                    { this.paginate() }
                    	</Col>
                    </Row>
                </Card>
                <ModalComponent
                	className="modal-lg"
                    isModal={ this.state.isModal }
                    content={this.state.contentModal}
                    isBtnConfirm={ this.state.isBtnConfirm }
                    isSpinner={ this.state.isSpinner }
                    btnConfirmDisabled={ this.state.btnConfirmDisabled }
                    hiddenModal={ () => this.hiddenModal() }
                    confirmModal={ () => this.confirmModal() }
                    alert={ this.state.alert }
                />
            </>	
		)
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminSendMail' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
	}
}


export default connect(mapStateToProps, mapDispatchToProps)(SendMailPage);